import { setEveqeqrblColorList, colorLuminance } from '@/helpers/colors'
import { defaultHotkeys } from '@/store/userSettings/hotkeys'
import { apiDict } from '@/store/userSettings/apiDicts'
// import mockUserSettings from '@/store/userSettings/mockUserSettings.json'

import {
  typographyColors,
  otherColors,
  trainerTableColors,
  actionsColors,
  suitsColors,
  ipOopColors,
  defaultStyles,
  defaultMics,
  defaultHeroTableSeats,
  defaultDashboardLinks,
  defaultTablesColumns,
  defaultTours,
} from '@/store/userSettings/settingsDefaults'

import { base } from '../api/client'
// import mock_plan from './mock_plan'

const getInitialState = () => {
  const mergedUserSettings = {
    actionsColors: actionsColors(),
    otherColors: otherColors(),
    suitsColors: suitsColors(),
    ipOopColors: ipOopColors(),
    hotkeys: defaultHotkeys(),
    heroTableSeats: defaultHeroTableSeats(),
    dashboardLinks: defaultDashboardLinks(),
    tablesColumns: defaultTablesColumns(),
    trainerTableColors: trainerTableColors(),
    typographyColors: typographyColors(),
    ...defaultMics(),
    ...defaultStyles(),
  }
  // console.log('getInitialState', mergedUserSettings)
  return {
    userSettings: {
      ...base(),
    },
    mergedUserSettings,
  }
}

const state = getInitialState()

const mergeUserSettings = result => {
  const apiFeDict = apiDict()
  // debugger
  function mergeByDict(defaults, apiData) {
    const res = {}
    Object.keys(defaults).forEach(key => {
      const dictVal = apiFeDict.find(e => e.feKey === key)
      if (dictVal?.apiKey in apiData) {
        if (apiData[dictVal.apiKey] !== null) {
          res[key] = apiData[dictVal.apiKey]
        }
      }
    })
    return res
  }

  function mergeDuplClrs(defaults, apiColors) {
    const res = {}
    Object.keys(defaults).forEach(key => {
      const dictVal = apiFeDict.find(e => e.feKey === key)
      if (apiColors[dictVal?.apiKey]) {
        let val = apiColors[dictVal.apiKey]
        if (dictVal.clrSecond) {
          val = val.split('#').filter(i => i)
          const clr1 = `#${val[0]}`
          const clr2 = `#${val[1] || val[0]}`
          res[dictVal.feKey] = clr1
          res[dictVal.clrSecond] = clr2
          if (dictVal.clrThird) {
            const clr3 = `#${val[2] || val[1] || val[0]}`
            res[dictVal.clrThird] = clr3
          }
        } else {
          res[key] = val
        }
      }
    })
    return res
  }

  const apiSettings = result.response?.data?.settings || {}

  let res = {}
  const apiColors = apiSettings.colors || {}
  const apiHotkeys = apiSettings.hotkeys || {}
  const apiMisc = apiSettings.misc || {}
  const apiStyles = apiSettings.styles || {}
  const apiHeroTableSeats = apiSettings.heroTableSeats || {}
  const apiDashboardLinks = apiSettings.dashboardLinks || null
  const apiTablesColumns = apiSettings.tablesColumns || null

  const userTrainerTableColors = mergeDuplClrs(trainerTableColors(), apiColors)
  res = {
    ...res,
    trainerTableColors: {
      ...trainerTableColors(),
      ...userTrainerTableColors,
    },
  }

  const userActionsColors = mergeDuplClrs(actionsColors(), apiColors)
  res = {
    ...res,
    actionsColors: {
      ...actionsColors(),
      ...userActionsColors,
    },
  }

  const userTypographyColors = mergeDuplClrs(typographyColors(), apiColors)
  res = {
    ...res,
    typographyColors: {
      ...typographyColors(),
      ...userTypographyColors,
    },
  }

  const userOtherColors = mergeDuplClrs(otherColors(), apiColors)
  res = {
    ...res,
    otherColors: {
      ...otherColors(),
      ...userOtherColors,
    },
  }

  const userSuitsColors = mergeByDict(suitsColors(), apiColors)
  res = {
    ...res,
    suitsColors: {
      ...suitsColors(),
      ...userSuitsColors,
    },
  }

  const userIpOopColors = mergeByDict(ipOopColors(), apiColors)
  res = {
    ...res,
    ipOopColors: {
      ...ipOopColors(),
      ...userIpOopColors,
    },
  }

  const userMisc = mergeByDict(defaultMics(), apiMisc)
  res = {
    ...res,
    ...defaultMics(),
    ...userMisc,
  }

  const userStyles = mergeByDict(defaultStyles(), apiStyles)
  res = {
    ...res,
    ...defaultStyles(),
    ...userStyles,
  }

  const hotkeys = defaultHotkeys()
  Object.keys(hotkeys).forEach(key => {
    const hotkeyValue = apiHotkeys?.[key]
    // Legacy --  A-Z was mapped to KeyS but forgot about locale issues
    // like switched keyboard layout so keep this here for a while
    let combination = [hotkeyValue || hotkeys[key]]
    combination = combination.flat() // legacy when it was just a string
    hotkeys[key] = combination.map(kk => kk.replace('Key', '').toLowerCase())
  })
  res = {
    ...res,
    hotkeys,
  }

  const heroTableSeats = defaultHeroTableSeats()
  Object.keys(heroTableSeats).forEach(key => {
    const val = apiHeroTableSeats?.[key]
    heroTableSeats[key] = val || heroTableSeats[key]
  })
  res = {
    ...res,
    heroTableSeats,
  }

  const dashboardLinks = apiDashboardLinks || defaultDashboardLinks()
  res = {
    ...res,
    dashboardLinks,
  }

  const tablesColumns = apiTablesColumns || defaultTablesColumns()
  res = {
    ...res,
    ...defaultTablesColumns(),
    tablesColumns,
  }

  return res
}

const actions = {
  resetHotkeys({ state, commit, dispatch, getters }) {
    dispatch('setHotkeys', { patchData: {} })
  },
  resetHeroTableSeats({ state, commit, dispatch, getters }) {
    dispatch('setHeroTableSeats', { patchData: {} })
  },

  setHeroTableSeats({ state, commit, dispatch, getters }, { patchData }) {
    const apiData = getters.api_get_data('api_account_settings') || {}
    const currentSettings = apiData.settings
    const patchSettings = {
      ...currentSettings,
      heroTableSeats: {
        ...defaultHeroTableSeats(),
        ...patchData,
      },
    }
    dispatch('setSettings', { currentSettings, patchSettings })
  },
  setHotkeys({ state, commit, dispatch, getters }, { patchData }) {
    const apiData = getters.api_get_data('api_account_settings') || {}
    const currentSettings = apiData.settings
    const patchSettings = {
      ...currentSettings,
      hotkeys: {
        ...defaultHotkeys(),
        ...patchData,
      },
    }
    dispatch('setSettings', { currentSettings, patchSettings })
  },
  setSettingsValue({ state, commit, dispatch, getters }, { key, patchData }) {
    const apiData = getters.api_get_data('api_account_settings') || {}
    const currentSettings = apiData.settings
    const patchSettings = {
      ...currentSettings,
      [key]: patchData,
    }
    dispatch('setSettings', { currentSettings, patchSettings })
  },
  setSettings({ state, commit, dispatch, getters }, { currentSettings, patchSettings }) {
    if (JSON.stringify(currentSettings) === JSON.stringify(patchSettings)) return
    const settings = { settings: patchSettings }
    const expectedResponse = { response: { data: settings } }
    commit('api_update', { key: 'api_account_settings', result: expectedResponse })
    dispatch('combineUserSettings', expectedResponse)
    dispatch('account_settings_patch', {
      data: { settings: patchSettings },
    })
  },

  userSettings({ state, commit, dispatch, getters }, { hasApiUpdate = true, ...values }) {
    const apiData = getters.api_get_data('api_account_settings') || {}
    const currentSettings = apiData.settings
    const patchSettings = JSON.parse(JSON.stringify(currentSettings))

    const apiFeDict = apiDict()
    Object.keys(values).forEach(key => {
      const dictVal = apiFeDict.find(e => e.feKey === key)
      if (dictVal?.clrSecond) {
        const clr1 = values[dictVal.feKey]
        const clr2 = values[dictVal.clrSecond]
        patchSettings[dictVal.category] = patchSettings[dictVal.category] || {}
        patchSettings[dictVal.category][dictVal.apiKey] = `${clr1 || ''}${clr2 || ''}`
        if (dictVal.clrThird) {
          const clr3 = values[dictVal.clrThird]
          patchSettings[dictVal.category][dictVal.apiKey] = `${clr1 || ''}${clr2 || ''}${
            clr3 || ''
          }`
        }
      } else if (dictVal) {
        patchSettings[dictVal.category] = patchSettings[dictVal.category] || {}
        patchSettings[dictVal.category][dictVal.apiKey] = values[key]
      }
    })

    // debugger
    if (JSON.stringify(currentSettings) === JSON.stringify(patchSettings)) return

    const settings = { settings: patchSettings }
    const expectedResponse = { response: { data: settings } }
    commit('api_update', { key: 'api_account_settings', result: expectedResponse })
    dispatch('combineUserSettings', expectedResponse)

    if (!hasApiUpdate) return
    dispatch('account_settings_patch', { data: settings })
  },
  combineUserSettings({ state, commit, dispatch, getters }, { ...result }) {
    dispatch('updateUserInfo', JSON.parse(JSON.stringify(result)))
    const updatedSettings = mergeUserSettings(result)
    if (JSON.stringify(state.mergedUserSettings) !== JSON.stringify(updatedSettings)) {
      // some settings are instantly preset locally via expectedResponse
      commit('mergedUserSettings', updatedSettings)
    }
  },
  settingsUpdateUserInfo({ state, commit, dispatch, getters }, { ...result }) {
    dispatch('updateUserInfo', JSON.parse(JSON.stringify(result)))
  },
  resetColorSettings(
    { state, commit, dispatch, getters },
    { mergedUserSettings } = { mergedUserSettings: null },
  ) {
    mergedUserSettings = mergedUserSettings || getters.mergedUserSettings

    const allColors = {
      ...mergedUserSettings.actionsColors,
      ...mergedUserSettings.typographyColors,
      ...mergedUserSettings.otherColors,
      ...mergedUserSettings.suitsColors,
      ...mergedUserSettings.ipOopColors,
      ...mergedUserSettings.trainerTableColors,
    }
    let eveqeqrbl_generated = false

    Object.keys(allColors).forEach(key => {
      if (key.includes('eveqeqrbl') && !eveqeqrbl_generated) {
        setEveqeqrblColorList({
          clr1: allColors.eveqeqrbl,
          clr2: allColors.eveqeqrbl_2,
          clr3: allColors.eveqeqrbl_3,
        })
        eveqeqrbl_generated = true
      } else if (key.includes('card_back')) {
        const hex = allColors.card_back
        const hex2 = colorLuminance(hex, -0.2)
        const hex3 = colorLuminance(hex, -0.4)
        document.documentElement.style.setProperty('--clr-card_back', hex)
        document.documentElement.style.setProperty('--clr-card_back2', hex2)
        document.documentElement.style.setProperty('--clr-card_back3', hex3)
      } else if (!key.includes('eveqeqrbl')) {
        const clrVar = `--clr-${key}`
        if (clrVar.includes('--clr-R')) {
          document.documentElement.style.setProperty(`${clrVar}`, allColors[key])
          document.documentElement.style.setProperty(`${clrVar}-initial`, allColors[key])
        }
        document.documentElement.style.setProperty(clrVar, allColors[key])
      }
    })

    const { actionBtnShadowStyle } = mergedUserSettings
    document.documentElement.style.setProperty(
      '--action-btn-text-shadow',
      `var(--text-${actionBtnShadowStyle})`,
    )
    const { rangeCellShadowStyle } = mergedUserSettings
    document.documentElement.style.setProperty(
      '--range-cell-text-shadow',
      `var(--text-${rangeCellShadowStyle})`,
    )
  },
}

const getters = {
  finishedStudyPlans: (state, getters) => {
    const apiData = getters.api_get_data('api_account_settings') || {}
    let res = apiData?.settings?.finishedStudyPlans || {}
    res = JSON.parse(JSON.stringify(res))
    return res
  },
  tours: (state, getters) => {
    const apiData = getters.api_get_data('api_account_settings') || {}
    // legacy support - lets delete after 2024 06 as this change will be saved to every user very soon
    const localFinishedTours = JSON.parse(localStorage.getItem('tours_finished') || 'null')
    // --
    const res = {
      ...defaultTours(),
      ...(localFinishedTours || {}),
      ...(apiData?.settings?.tours || {}),
    }
    return res
  },
  userSettings: state => JSON.parse(JSON.stringify(state.userSettings)),
  mergedUserSettings: state => JSON.parse(JSON.stringify(state.mergedUserSettings)),
  actionsColors: state => state.mergedUserSettings.actionsColors,
  heroTableSeats: state => state.mergedUserSettings.heroTableSeats,
  dashboardLinks: state => state.mergedUserSettings.dashboardLinks,
  tablesColumns: state => state.mergedUserSettings.tablesColumns,
  showLegacySolutions: state => state.mergedUserSettings.showLegacySolutions,
  keepFiltersBetweenSpots: state => state.mergedUserSettings.keepFiltersBetweenSpots,
  gmfStacksTableAsGrid: state => state.mergedUserSettings.gmfStacksTableAsGrid,
  showHandValue: state => state.mergedUserSettings.showHandValue,
  solfigrDashboard: state => state.mergedUserSettings.solfigrDashboard,
  favoriteMainDrills(state) {
    const { mergedUserSettings } = state
    return mergedUserSettings?.favoriteMainDrills || []
  },
}

const mutations = {
  userSettings(state, result) {
    state.userSettings = result
    if (result.response) {
      state.mergedUserSettings = mergeUserSettings(result)
    }
  },
  mergedUserSettings(state, result) {
    Object.keys(result).forEach(key => {
      if (JSON.stringify(state.mergedUserSettings[key]) !== JSON.stringify(result[key])) {
        state.mergedUserSettings[key] = result[key]
      }
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
